import { CSS as MenuCSS } from '../../components/menu/menu.style';

export const CSS = {
	container: 'c-StatusCollections',
	isLoading: 'c-StatusCollections--IsLoading',
	content: 'c-StatusCollections__Content',
	contentSecond: 'c-StatusCollections__Content__second',
	list: 'c-StatusCollections__List',
	menu: 'c-StatusCollections__Menu',
};

export const Style = {
	[CSS.container]: {
		width: '600px',
	},
	[CSS.isLoading]: {
		display: 'flex',
		'justify-content': 'center',
	},
	[CSS.content]: {
		display: 'flex',
		'align-items': 'baseline',
		'justify-content': 'space-around',
	},
	[CSS.contentSecond]: {
		display: 'flex',
		'align-items': 'baseline',
		'justify-content': 'space-between',
	},
	[CSS.list]: {
		'list-style-type': 'none',
		'padding-left': 0,
	},
	[CSS.menu]: {
		width: '600px',
		position: 'absolute',
		[`& .${MenuCSS.menu}`]: {
			right: 'auto',
			width: '100%',
		},
	},
};
